// 나의 검사 관리(업무 화면) 공통 설정 — 시험 3종 메타 · LNB 메뉴 구조 (IA 변경안 4-x-x)

// 시험 구분(LNB 시험 카드) ↔ tb_exam.exam_se
//  표준화시험 = MAIN(서논술형은 SEM1·SEM2), 예비시험 = PRE, 시범시험(캠프) = CUSTOM(비공개 검사)
const CATEGORY = {
  STANDARD: { key: "STANDARD", label: "표준화시험", short: "표준화" },
  PRE: { key: "PRE", label: "예비시험", short: "예비", se: ["PRE"] },
  CAMP: { key: "CAMP", label: "시범시험(캠프)", short: "시범", se: ["CUSTOM"] },
};

export const WORKSPACE_EXAMS = [
  {
    type: "MLSRD",
    label: "문해력·수리력 진단검사(S-PLAN)",
    title: "서울 학생 문해력·수리력 진단검사(S-PLAN)",
    short: "S-PLAN",
    categories: [{ ...CATEGORY.STANDARD, se: ["MAIN"] }, CATEGORY.CAMP],
  },
  {
    type: "LITERACY",
    label: "AI·디지털 리터러시 진단검사",
    title: "서울 학생 AI·디지털 리터러시 진단검사",
    short: "AI·DL",
    categories: [{ ...CATEGORY.STANDARD, se: ["MAIN"] }, CATEGORY.PRE, CATEGORY.CAMP],
  },
  {
    type: "ESSAY",
    label: "AI·서논술형 평가(채움AI)",
    title: "AI·서논술형 평가 지원 시스템(채움AI)",
    short: "채움AI",
    categories: [{ ...CATEGORY.STANDARD, se: ["SEM1", "SEM2"] }, CATEGORY.CAMP],
  },
];

// 메뉴 활성 판정: 라우트 name 일치 또는 pathPrefix(es) 하위 경로 (grading ≠ grading-paper)
const matchPrefix = (path, prefix) => path === prefix || path.startsWith(`${prefix}/`);
export const isWorkspaceMenuActive = (item, route) =>
  route.name === item.route ||
  [item.pathPrefix, ...(item.pathPrefixes || [])]
    .filter(Boolean)
    .some((prefix) => matchPrefix(route.path, prefix));

export const getWorkspaceExam = (type) =>
  WORKSPACE_EXAMS.find((exam) => exam.type === type) ?? WORKSPACE_EXAMS[0];

// LNB 메뉴. route: 라우트 name, pathPrefix: 하위 탭 라우트가 있는 메뉴의 활성 판정용
// requiresSchoolAdmin / requiresGradingAccess: 기존 나의 검사 탭과 같은 노출 규칙
// exams: 해당 시험에서만 노출 (없으면 전체), hidden: 기획 확정 전까지 메뉴에서 숨김(라우트는 유지)
// access: 채점 관리 하위 메뉴 노출 대상 (WorkspaceLnb 에서 판정)
//   graderOnly 순수 채점자 · scoring 채점 권한자/담임/교장·교감 · schoolAdmin 학교관리자 · leader 회차 내 팀장
export const WORKSPACE_MENU = [
  { id: "plan", label: "시험 계획", icon: "plan", route: "MyTestTeacherPlan" },
  { id: "items", label: "문항 관리", icon: "items", route: "MyTestTeacherItems", hidden: true },
  {
    id: "rehearsal",
    label: "예행 연습",
    icon: "rehearsal",
    hidden: true,
    children: [
      { id: "rh-proctor", label: "시험감독 체험하기", route: "MyTestTeacherRehearsalProctor" },
      { id: "rh-student", label: "학생 응시 체험하기", route: "MyTestTeacherRehearsalStudent" },
      { id: "rh-grading", label: "채점 체험하기", route: "MyTestTeacherRehearsalGrading" },
    ],
  },
  {
    id: "check",
    label: "사전 점검",
    icon: "check",
    children: [
      { id: "ck-digital", label: "디지털 평가", route: "MyTestTeacherPreCheck" },
      // 종이 기반 평가: 미적용 기능이라 숨김 (라우트는 유지)
      { id: "ck-paper", label: "종이 기반 평가", route: "MyTestTeacherPreCheckPaper", hidden: true },
    ],
  },
  { id: "proctor", label: "시험 감독", icon: "proctor", route: "MyTestTeacherWatch" },
  {
    id: "grading",
    label: "채점 관리",
    icon: "grading",
    requiresGradingAccess: true,
    exams: ["ESSAY"],
    // 세부 단계는 제목 카드 탭(GradingManage 가 Teleport)으로 표시
    // 순서: (공지사항 · 순수 채점자) → 채점 진행 → 채점 운영 → 채점자 등록
    children: [
      {
        id: "gr-notice",
        label: "공지사항",
        route: "MyTestTeacherGradingNotice",
        pathPrefix: "/my-test/teacher/grading/notice",
        access: "graderOnly",
      },
      {
        id: "gr-score",
        label: "채점 진행",
        route: "MyTestTeacherGradingCriteria",
        pathPrefixes: [
          "/my-test/teacher/grading/criteria",
          "/my-test/teacher/grading/first",
          "/my-test/teacher/grading/second",
          "/my-test/teacher/grading/feedback",
          "/my-test/teacher/grading/education-answer-select",
        ],
        access: "scoring",
      },
      {
        id: "gr-monitor",
        label: "채점 운영",
        route: "MyTestTeacherGradingLeader",
        pathPrefix: "/my-test/teacher/grading/leader",
        access: "leader",
      },
      {
        id: "gr-grader",
        label: "채점자 등록",
        route: "MyTestTeacherGradingGrader",
        pathPrefix: "/my-test/teacher/grading/grader",
        access: "schoolAdmin",
      },
      { id: "gr-paper", label: "종이 기반 평가", route: "MyTestTeacherGradingPaper", hidden: true },
    ],
  },
  { id: "result", label: "결과 관리", icon: "result", route: "MyTestTeacherResult" },
];

// 숨김(·권한 밖) 하위 메뉴를 걷어내고, 하위 메뉴가 하나만 남은 그룹은 그 화면으로 바로 가는 단일 메뉴로 만든다
export const resolveWorkspaceMenu = (isChildVisible = () => true, items = WORKSPACE_MENU) =>
  items
    .filter((item) => !item.hidden)
    .map((item) => {
      if (!item.children) return item;
      const children = item.children.filter((child) => !child.hidden && isChildVisible(child));
      if (children.length === 1) {
        const [only] = children;
        return {
          ...item,
          children: undefined,
          route: only.route,
          pathPrefix: only.pathPrefix,
          pathPrefixes: only.pathPrefixes,
        };
      }
      return { ...item, children };
    })
    .filter((item) => item.route || item.children?.length);
